import { render, staticRenderFns } from "./AdminBotImages.vue?vue&type=template&id=dd43a9e4&scoped=true&"
import script from "./AdminBotImages.vue?vue&type=script&lang=js&"
export * from "./AdminBotImages.vue?vue&type=script&lang=js&"
import style0 from "./AdminBotImages.vue?vue&type=style&index=0&id=dd43a9e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd43a9e4",
  null
  
)

export default component.exports